// 客户费率模板

import { HttpProductManageList,
    HttpExportProductManage,
    HttpPushProductManage,
    HttpImportProduct,
    HttpDownloadProductTemplate,
    HttpGetBtachAllAction,
    HttpGetProductNumber,
    HttpImportProductValue,
    HttpDownloadProductValueTemplate
} from '@/service/setting';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compDetail from './detail';
import mixin from './mixin';
import compInventory from '../../products/allproducts/inventory'
import compUpdate from './update'
import compErpSkuMultipleInput from "./skumultiple";
import '@/style/product-icon.scss'
// import erpSkuInput from "@components/templates/erpskuinput";
export default {
    mixins: [TableList, mixin],
    components: {
        compDetail,
        compInventory,
        compUpdate,
        compErpSkuMultipleInput
        // erpSkuInput
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: {show: true},
            spanTabs: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            formData: {
                search: {
                    EQ_enable: null
                }
            }
        };
    },
    methods: {
        ajaxRequest: HttpProductManageList,
        spanAjaxRequest:HttpGetProductNumber,
        interceptRequest(params){
            // console.log(params)
            if (params.search.EQ_checkStatus === '0') {
                params.search.EQ_checkStatus = '0';
                params.search.EQ_enable = 1;
                params.search.EQ_isCheck = 0;

            }
            if (params.search.EQ_checkStatus === '4') {
                params.search.EQ_checkStatus = null;
                params.search.EQ_isError = 1;
                params.search.EQ_enable = 1;
            }
            if (params.search.EQ_checkStatus === '5') {
                params.search.EQ_checkStatus = 0;
                params.search.EQ_isCheck = 1;
                params.search.EQ_enable = 1;
            }

            return params
        },
        handleOperates(params, type, batch) {
            // console.log(params)
            let erpparams;
            if(batch===true){
                // console.log(this.checkedRowData)
                let idslist = this.checkedRowData.map(item=>{ return item.id });
                let erpskulist = this.checkedRowData.map(item=>{ return item.erpSku});
                params=(params||idslist.join(','))+'';
                erpparams=(erpskulist.join(','))+'';
                if (!params.length || !erpparams.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: "请选择至少一条数据" }));
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: "查看" }),
                        show: true,
                        width: 'large',
                        component: "compDetail",
                        showFooter: false,
                        params,
                    }
                    break;
                case 'push':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: {
                            skus: erpparams
                        },
                        title: this.$t('erp.common.push_warehouse', { defaultValue: "推送仓库" }),
                        ajaxRequest: HttpPushProductManage
                    }
                    break;
                case 'export':
                    this.handleWebfs(HttpExportProductManage, this.formData, { executor: 'request', download: true });
                    break;
                case 'inventory':
                    this.operate = {
                        title: this.$t("global.common.operation_see", { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compInventory",
                        comperpsku: params,
                        isProductManage: true,
                        isManage: true,
                        showFooter: false,
                    }
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: this.$t('global.common.import_calc', { defaultValue: "导入产品管理属性" }),
                        width: 460,
                        showFooter: false,
                        name: "excelFile",
                        component: "compUpload",
                        ajaxRequest: HttpImportProduct,
                        download: () => {
                            this.handleWebfs(HttpDownloadProductTemplate, {}, {
                                fileName: 'productManage.xls',
                                download: true
                            });
                        }
                    };
                    break;
                case "importValue":
                    this.operate = {
                        show: true,
                        title: this.$t('erp.product.import_product_value', { defaultValue: "导入产品估值" }),
                        width: 460,
                        showFooter: false,
                        name: "excelFile",
                        component: "compUpload",
                        ajaxRequest: HttpImportProductValue,
                        download: () => {
                            this.handleWebfs(HttpDownloadProductValueTemplate, {}, {
                                fileName: 'productManage.xls',
                                download: true
                            });
                        }
                    };
                    break;
                case 'edit_calc':
                    this.operate = {
                        title: this.$t('erp.product.edit_calc', { defaultValue: "编辑产品计费系数" }),
                        show: true,
                        width: 1000,
                        component: "compUpdate",
                        showFooter: false,
                        params,
                    }
                    break;
                case 'approved':
                    this.operate = {
                        show: true,
                        alert: "success",
                        params: {
                            ids: params,
                            type:1,
                        },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('erp.productmanage.tip_reason', { defaultValue: "备注原因" }),
                                required:false,
                            }
                        ],
                        title: this.$t('erp.product.batch_approved', { defaultValue: "批量审核通过" }),
                        ajaxRequest: HttpGetBtachAllAction
                    }
                    break;
                case 'rejected':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: {
                            ids: params,
                            type:2,
                        },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('erp.productmanage.tip_reason', { defaultValue: "备注原因" }),
                                required:false,
                            }
                        ],
                        title: this.$t('erp.product.batch_rejecteed', { defaultValue: "批量审核驳回" }),
                        ajaxRequest: HttpGetBtachAllAction
                    }
                    break;
                case 'ignore':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: {
                            ids: params,
                            type:4,
                        },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('erp.productmanage.tip_reason', { defaultValue: "备注原因" }),
                                required:false,
                            }
                        ],
                        title: this.$t('erp.product.batch_ignore', { defaultValue: "批量忽略" }),
                        ajaxRequest: HttpGetBtachAllAction
                    }
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: "查看" }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('erp.product.edit_calc', { defaultValue: "编辑产品计费系数" }),
                show: true,
                params: id,
                operate: 'edit_calc'
            },
            ]
        },
    },
    computed: {
        ...mapGetters('common', ['getProductsSizeList']),
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList']),
        ...mapGetters('diction', ['getNewDifferentAllProductList']),
        TabsData(){
            return [
                {
                    name: this.$t('myexample.product.list.all', { defaultValue: "所有产品" }),
                    key:'EQ_checkStatus',
                    val: null,
                    spanKey: 'All',
                }, {
                    name: this.$t('fbb.inbound.check_pending', { defaultValue: "待审核" }),
                    key:'EQ_checkStatus',
                    val: '0',
                    spanKey: 'pending',
                }, {
                    name: this.$t('erp.product.ignore_ppending', { defaultValue: "待审核-暂不处理" }),
                    key:'EQ_checkStatus',
                    val: '5',
                    spanKey: 'pass',
                }, {
                    name: this.$t('erp.product.check_refused', { defaultValue: "审核驳回" }),
                    key: "EQ_checkStatus",
                    val: '2',
                    spanKey: 'reject',
                }, {
                    name: this.$t('erp.product.warehouse_error', { defaultValue: "仓库复测异常" }),
                    key: "EQ_checkStatus",
                    val: '4',
                    spanKey: 'error',
                }
            ]
        },
        ToolsData() {
            return [{
                name: this.$t('erp.common.push_warehouse', { defaultValue: "推送仓库" }),
                operate: "push",
                theme: "primary",
                batch: true,
            },
            {
                name: this.$t('erp.product.batch_approved', { defaultValue: "批量审核通过" }),
                operate: "approved",
                batch: true,
                more: true,
            },
            {
                name: this.$t('erp.product.batch_rejecteed', { defaultValue: "批量审核驳回" }),
                operate: "rejected",
                batch: true,
                more: true,
            },
            {
                name: this.$t('erp.product.batch_ignore', { defaultValue: "批量忽略" }),
                operate: "ignore",
                batch: true,
                more: true,
            },
            {
                name: this.$t('global.common.import_calc', { defaultValue: "导入产品管理属性" }),
                operate: "import",
                more: true
            },
            {
                name: this.$t('erp.product.import_product_value', { defaultValue: "导入产品估值" }),
                operate: "importValue",
                more: true
            },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.cusorg', { defaultValue: "客户组织" }),
                    key: 'IN_orgId',
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    show: true,
                },
                {
                    label: this.$t('global.common.sku', { defaultValue: "SKU" }),
                    key: 'IN_erpSku',
                    show: true,
                    // tag: 'vInput',
                    tag: 'div',
                    removeInput: true,
                    style: {
                        "width": "300px"
                    },
                    children: (h) => {
                        return h(compErpSkuMultipleInput, {
                            props: {
                                value: this.formData.search.IN_erpSku,
                                erpskutype:'manage',
                                inputProps: {
                                    placeholder: "一行一个"
                                }
                            },
                            on: {
                                'on-data': (data) => {
                                    this.formData.search.IN_erpSku = data;
                                },
                            }
                        })
                    }
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    show: true,
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'EQ_enable',
                    tag: 'vSelect',
                    options: this.getProductStatus.slice(1),
                },
                {
                    label: this.$t('erp.setting.goods_type', { defaultValue: "产品类型" }),
                    key: 'EQ_productType',
                    tag: 'vSelect',
                    options: this.getProductType,
                },
                {
                    label: this.$t('global.common.auditstatus', { defaultValue: "审核状态" }),
                    key: 'IN_checkStatus',
                    tag: 'Select',
                    options: this.getCheckStatus.slice(0,3),
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                },
                {
                    label: this.$t('erp.setting.goodsstatus', { defaultValue: '产品状况' }),
                    key: "CN_productMidCondition",
                    tag: "vInput"
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    formName: 'erpSku',
                    width: 60,
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('global.common.cusorg', { defaultValue: "客户组织" }),
                    key: 'orgName',
                }, {
                    title: this.$t('global.common.sku', { defaultValue: "SKU" }) + '/' + this.$t('erp.product.customise_product_code', { defaultValue: '自定义产品编码' }),
                    // title: this.$t('global.common.sku', { defaultValue: "SKU" }),
                    key: 'erpSku',
                    width: 200,
                    render: (h, { row }) => {
                        let isContainBattery = (
                            <div class="icon-padding isContainBattery" data-desc={this.$t('erp.product.include_battery', { defaultValue: '含电池' })}>
                                <Icon class="my-icon" type="md-battery-charging" />
                            </div>
                        )
                        let isMagnetism = (
                            <div class="icon-padding isMagnetism" data-desc={this.$t('erp.product.include_mangent', { defaultValue: '带磁' })}>
                                <Icon class="my-icon" type="ios-magnet" />
                            </div>
                        )
                        let isLiquid = (
                            <div class="icon-padding isLiquid" data-desc={this.$t('erp.product.include_liquid', { defaultValue: '含液体' })}>
                                <Icon class="my-icon" type="ios-water-outline" />
                            </div>
                        )
                        let shapeType = (
                            <div class="icon-padding shapeType" data-desc={this.$t('erp.product.differentform', { defaultValue: '异形体' })}>
                                <Icon class="my-icon" type="ios-bookmark" />
                            </div>
                        )
                        let isFragile = (
                            <div class="icon-padding isFragile" data-desc={this.$t('erp.product.fraglie', { defaultValue: '易碎' })}>
                                <Icon class="my-icon" type="ios-wine" />
                            </div>
                        )
                        return (
                            <div>
                                <div class="icon-main-container">
                                    <div>
                                        <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.erpSku}</a>
                                    </div>
                                    <div class="icon-container">
                                        {row.isContainBattery ? isContainBattery : ''}
                                        {row.isMagnetism ? isMagnetism : ''}
                                        {row.isLiquid ? isLiquid : ''}
                                        {row.shapeType ? shapeType : ''}
                                        {row.isFragile ? isFragile : ''}
                                    </div>
                                </div>
                                <div>{row.erpSkuCode}</div>
                            </div>
                        )
                    }
                }, {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'lineId',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId),
                },
                {
                    title: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'enable',
                    render: (h, { row }) => this.findRenderLabel(this.getProductStatus, row.enable),
                },
                {
                    title: this.$t('global.common.auditstatus', { defaultValue: "审核状态" }),
                    key: 'enable',
                    render: (h, { row }) => this.findRenderLabel(this.getCheckStatus, row.checkStatus),
                },
                {
                    title: this.$t('erp.setting.goods_nameEn', { defaultValue: "品名(英文)" }),
                    key: 'nameEn',
                }, {
                    title: this.$t('erp.setting.goods_size', { defaultValue: "单品包装尺寸(inch)" }),
                    key: 'length',
                    render: (h, { row }) => {
                        return `${this.handleUnit(row.length, 'cm', 'inch')}*${this.handleUnit(row.width, 'cm', 'inch')}*${this.handleUnit(row.height, 'cm', 'inch')}`
                    }
                }, {
                    title: this.$t('erp.setting.goods_weight', { defaultValue: "毛重(lb)" }),
                    key: 'weight',
                    render: (h, { row }) => this.handleUnit(row.weight, 'g', 'lb')
                },
                {
                    title: this.$t("erp.setting.goods_packingType", { defaultValue: "发货包装类型", }),
                    key: "packingType",
                },
                {
                    title: this.$t('erp.setting.goods_size_1', { defaultValue: "FBA Size" }),
                    key: 'size',
                    width: 140,
                    render: (h, { row }) => {
                        const { color, label } = this.getProductsSizeList[row.packingSizeType];
                        return <span class={color}>{label || '--'}</span>
                    }
                },
                {
                    title: "Cope Size",
                    key: "chargeSizeType",
                    render: (h, { row }) => {
                        let sizeItem = this.getChargeSizeType.find(item => {
                            return item.value == row.chargeSizeType;
                        }) || {};
                        return <span class={sizeItem.theme || ""}>{sizeItem.label || "--"}</span>
                    }
                },
                {
                    title: this.$t('erp.setting.fobPrice', { defaultValue: "FOB（美元）" }),
                    key: 'fobPrice',
                }, {
                    title: this.$t('erp.setting.inventory', { defaultValue: "库存量" }),
                    key: 'inventory',
                    render: (h, { row }) => {
                        return <a onClick={this.handleOperates.bind(this, { erpsku: row.erpSku, qty: row.inventory }, 'inventory')}>{row.inventory === null ? '--' : row.inventory}</a>
                    }
                }, {
                    title: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    key: 'updatedAt',
                }];
        },
    },
};




